import { css, cva } from '@lastbrand/web-ui-styled-system/css'

// Panda twin of ProductInfoPrice.module.scss; legacy is fluid-rem (~10px root), sizes mapped by intended px.

export const priceWrapperCss = css({ display: 'flex' })

export const priceWrapperNewDesignV2Css = css({ alignItems: 'center' })

export const priceWrapperOfferColumnCss = css({ flexDirection: 'column', width: 'auto' })

export const priceWrapperFestivalOfferNewDesignV2Css = css({
  alignItems: 'unset',
  color: 'mediumgray',
  textStyle: 'body-20',
  lineHeight: '24px', // legacy 2.4rem
})

export const priceWrapperSubscriptionOfferNewDesignV2Css = css({
  alignItems: 'unset',
  color: 'mediumgray',
  textStyle: 'body-20',
  lineHeight: '24px', // legacy 2.4rem
  mb: 'space-4',
})

export const priceWrapperMainCss = css({ display: 'block' })

export const priceWrapperMainOfferRowCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
})

// Parity hook for legacy `__space`; no extra declarations.
export const priceWrapperMainSpaceCss = css({})

export const priceWrapperMainValueCss = css({
  textStyle: 'body-18',
  display: 'flex',
  alignItems: 'center',
  // pin lg explicitly (`lg: undefined` would not reset the 22px base).
  fontSize: { base: '22px', lg: '18px' },
})

export const priceWrapperMainValueQpCss = css({
  width: 'fit-content',
  mr: { base: '43px', lg: 'space-56' },
})

export const priceWrapperMainValueQpOfferCss = css({
  width: 'fit-content',
  mr: 0,
})

export const priceWrapperMainValueQpOfferOriginalCss = css({
  color: 'mediumgray',
  textDecoration: 'line-through',
})

export const priceWrapperMainValueQpNewDesignV2Css = css({
  textStyle: 'body-20-strong',
  lineHeight: '24px', // legacy 2.4rem
  mr: 'space-8',
})

export const priceWrapperMainValueQpNewDesignV2FestivalPriceCss = css({
  fontWeight: 400,
  textDecorationLine: 'line-through',
})

// Parity placeholder; no distinct legacy rule.
export const priceWrapperMainValueQpUpdatedDesignV2Css = css({})

export const priceWrapperMainValueRpCss = css({
  opacity: 1,
  color: 'mediumgray',
  textDecoration: 'line-through',
})

// Not layered on priceWrapperMainValueCss so its 12px size isn't overridden by that base's responsive rule.
export const priceWrapperMainValueRpOfferCss = css({
  display: 'flex',
  alignItems: 'center',
  textStyle: 'body-12',
  lineHeight: '24px',
  width: 'auto',
})

export const priceWrapperMainValueRpNewDesignV2Css = css({
  textStyle: 'body-14',
  color: 'mediumgray',
})

// Weight only; the no-strikethrough is resolved via the decoration recipe below.
export const priceWrapperMainValueRpNewDesignV2FestivalWeightCss = css({
  fontWeight: 400,
})

// cva variant merge is deterministic (variant overrides base) so textDecoration resolves cleanly.
export const priceWrapperMainValueRpDecorationRecipe = cva({
  base: { opacity: 1, color: 'mediumgray' },
  variants: { festival: { true: { textDecoration: 'none' }, false: { textDecoration: 'line-through' } } },
})

// Parity placeholder; no distinct legacy rule.
export const priceWrapperMainValueRpUpdatedDesignV2Css = css({})

export const priceWrapperMainValuePerservingCss = css({
  textStyle: 'body-14',
  fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
  fontWeight: 400,
  ml: 'space-4',
})

export const priceWrapperMainValuePerservingNewDesignV2Css = css({
  textStyle: 'body-12',
  fontWeight: 400,
})

export const priceWrapperMainValuePerservingTraditionalCss = css({
  color: 'mediumgray',
  textDecoration: 'line-through',
})

export const priceWrapperMainValuePerservingTraditionalNewPdpDesignV2Css = css({
  mr: 'space-4',
})

export const priceWrapperMainTextCss = css({
  textStyle: 'body-12',
  fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
  fontWeight: 400,
  opacity: 1,
  color: 'mediumgray',
})

export const priceWrapperMainTextNewDesignV2Css = css({
  color: 'mediumgray',
})

// Parity placeholder; no distinct legacy rule.
export const priceWrapperMainTextUpdatedDesignV2Css = css({})

export const priceWrapperMainTextRpCss = css({
  whiteSpace: 'nowrap',
})

export const priceWrapperMainMarginCss = css({ mt: 'space-4' })

export const priceWrapperTraditionalRetailInlineCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  mt: 'space-4',
})

// Parity placeholder; no distinct legacy declarations.
export const priceWrapperMainFinalSaleNewDesignV2Css = css({})

// cva variant merge is deterministic (variant overrides base) so the 3P override wins.
export const finalSaleChipRecipe = cva({
  base: {
    paddingBlock: 'space-4',
    paddingInline: 'space-8',
    '& span': {
      color: 'black',
      textAlign: 'center',
      textStyle: 'body-12',
      fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
      fontWeight: 400,
      display: 'block',
    },
  },
  variants: {
    thirdParty: {
      false: { backdropFilter: 'blur(2px)', background: 'paperwhite', ml: 'space-4' },
      true: {
        backdropFilter: 'blur(2.5px)',
        background: 'offwhite',
        ml: 0,
        textStyle: 'body-12',
        fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
        fontWeight: 400,
      },
    },
  },
})

export const priceWrapperMainEarnCreditTagCss = css({
  paddingBlock: 'space-4',
  paddingInline: 'space-6',
  textStyle: 'body-12',
  fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
  fontWeight: 400,
  background: 'cantaloupe-80',
  backdropFilter: 'blur(2px)',
  ml: 'space-8',
})

export const priceWrapperMainThirdPartyMsgCss = css({
  textStyle: 'body-12',
  lineHeight: '24px', // legacy 2.4rem
  color: 'mediumgray',
  fontWeight: 400,
  mt: 'space-4',
})

export const festivalOfferCss = css({
  color: 'red-100',
  textDecoration: 'initial',
})

export const festivalOfferNewDesignV2Css = css({
  fontWeight: 500,
  lineHeight: '24px', // legacy 2.4rem
  color: 'red-100',
  textDecoration: 'none',
  textStyle: 'body-20',
  ml: 'space-4',
})

export const subscriptionOfferCss = css({
  color: 'black',
  textDecoration: 'initial',
})

export const subscriptionOfferNewDesignV2Css = css({
  fontWeight: 500,
  lineHeight: '24px', // legacy 2.4rem
  color: 'black',
  textDecoration: 'none',
  textStyle: 'body-20',
  ml: 'space-4',
})

export const b2bFinalSaleTextWrapperCss = css({ height: 'fit-content' })

export const b2bPriceWrapperCss = css({ mr: 'space-10' })
